import type { ReactNode } from 'react';
import Chip from '@mui/material/Chip';
import CircleIcon from '@mui/icons-material/Circle';

/** Shared interior-page hero: grid-texture background + eyebrow/title/subtitle, matches Hero.tsx. */
export function PageHero({
  eyebrow,
  title,
  subtitle,
  children,
}: {
  eyebrow: string;
  title: ReactNode;
  subtitle?: ReactNode;
  children?: ReactNode;
}): JSX.Element {
  return (
    <section className="relative overflow-hidden pt-16 pb-12 md:pt-24 md:pb-16">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 bg-nexus-grid bg-grid [mask-image:radial-gradient(circle_at_50%_0%,#000,transparent_70%)]"
      />
      <div className="container-content relative">
        <div className="mx-auto max-w-2xl text-center">
          <Chip
            icon={<CircleIcon sx={{ fontSize: '8px !important', color: '#b06bff' }} />}
            label={eyebrow}
            size="small"
            className="mb-5 border border-nexus-purple/30 bg-nexus-purple/[0.14] font-semibold text-nexus-purple-light"
          />
          <h1 className="font-display text-4xl font-bold leading-[1.1] tracking-tight text-nexus-ink md:text-[46px]">
            {title}
          </h1>
          {subtitle && <p className="mt-5 text-lg text-white/70">{subtitle}</p>}
        </div>
        {children}
      </div>
    </section>
  );
}
